var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSchoolWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_62890)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 24,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2002 44.7999L14.0898 36.1317C12.6236 33.6656 11.7795 30.7876 11.7795 27.7103C11.7795 18.592 19.1715 11.2 28.2898 11.2C37.4082 11.2 44.8002 18.592 44.8002 27.7103C44.8002 36.8286 37.4082 44.2206 28.2898 44.2206C25.5155 44.2206 22.9028 43.533 20.6082 42.3246L11.2002 44.7999Z",
    fill: "#2CB742"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8228 33.2052C38.0604 31.7645 35.249 30.1169 35.249 30.1169C34.613 29.7543 33.8454 29.7137 33.4827 30.3603C33.4827 30.3603 32.5692 31.4557 32.3369 31.6133C31.2756 32.3322 30.2925 32.3044 29.3001 31.3121L26.9939 29.0058L24.6876 26.6996C23.6953 25.7072 23.6675 24.7241 24.3864 23.6628C24.544 23.4305 25.6394 22.517 25.6394 22.517C26.286 22.1537 26.2454 21.3867 25.8828 20.7507C25.8828 20.7507 24.2352 17.9393 22.7945 17.1769C22.1815 16.8525 21.429 16.966 20.9389 17.4561L19.9205 18.4745C16.6897 21.7054 18.2805 25.3527 21.5113 28.5835L24.464 31.5363L27.4168 34.489C30.6476 37.7198 34.2949 39.3106 37.5257 36.0798L38.5442 35.0614C39.0343 34.5701 39.1472 33.8176 38.8228 33.2052Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_62890",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_62890"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_62890",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchoolWhatsapp);
export default __webpack_public_path__ + "static/media/icon_school_whatsapp.7865f676d09968dce68d73f0678aa4da.svg";
export { ForwardRef as ReactComponent };